/* ============================================================
   DR JERRAR — barre de progression de lecture (pages article)
   Progression calculee sur le defilement de la page entiere :
   fiable meme pour les articles courts.
   ============================================================ */
(function(){
  "use strict";
  var bar = document.getElementById("readprogress");
  if (!bar) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    bar.style.transition = "none";
  }

  var ticking = false;
  function update(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      var doc   = document.documentElement;
      var total = (doc.scrollHeight || 0) - window.innerHeight;
      var p     = total > 0 ? (window.scrollY || doc.scrollTop || 0) / total : 0;
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      bar.style.width = (p * 100).toFixed(2) + "%";
      bar.setAttribute("aria-valuenow", Math.round(p * 100));
      ticking = false;
    });
  }

  bar.setAttribute("aria-valuemin", "0");
  bar.setAttribute("aria-valuemax", "100");
  window.addEventListener("scroll", update, {passive:true});
  window.addEventListener("resize", update, {passive:true});
  window.addEventListener("load", update);
  update();
})();
